import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutFakProfileLookup } from "./autogen/AutogenLayoutFakProfileLookup";

export class FakProfileLookup extends AutogenLayoutFakProfileLookup {

    tableFakProfileOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }
}
